'use client';

import { Button, Translation } from '@/ui/components';

const SignInButton = () => {
  return (
    <Button isFullWidth href={`/account/login`}>
      <Translation context="register" token="sign_in" />
    </Button>
  );
};

export default SignInButton;
